import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useOtpBlockCountdown } from "../../../hooks/useOtpBlockCountdown";
import { usePinLoginBlockStore } from "../../../stores/useOtpBlockStore";

const AppAccessGuard = ({ children }) => {
  const navigate = useNavigate();
  const { isBlocked } = useOtpBlockCountdown(usePinLoginBlockStore);

  useEffect(() => {
    if (isBlocked) {
      navigate("/auth/login", { replace: true });
    }
  }, [isBlocked, navigate]);

  if (isBlocked) return null;

  return children;
};

export default AppAccessGuard;
